import "../css/CircularLoading.css";

const CircularLoading = () => {
  return (
    <div className='wrapper'>
      <div className='loading'></div>
    </div>
  );
};

export default CircularLoading;
